import { MapCoordinatesFinderComponent } from './map-coordinates-finder.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http'
import { RadioModule } from '@components/radio/radio.module'
import { NumberInputModule } from '@components/number-input/number-input.module'

@NgModule({
  declarations: [MapCoordinatesFinderComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ContentEditableModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RadioModule,
    NumberInputModule,
  ],
  exports: [MapCoordinatesFinderComponent],
})
export class MapCoordinatesFinderModule {}
